import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="container">
                <div className="col">
                    <h4>Products</h4>
                    <p>App</p>
                    <p>Analytics</p>
                    <p>Token Lists</p>
                    <p>Defi</p>
                </div>
                <div className="col">
                    <h4>Developers</h4>
                    <p>App</p>
                    <p>Analytics</p>
                    <p>Token Lists</p>
                    <p>Defi</p>
                </div>
                <div className="col">
                    <h4>Governance</h4>
                    <p>App</p>
                    <p>Analytics</p>
                    <p>Token Lists</p>
                    <p>Defi</p>
                </div>
                <div className="col">
                    <h4>Community</h4>
                    <p>App</p>
                    <p>Analytics</p>
                    <p>Token Lists</p>
                    <p>Defi</p>
                </div>
                <div className="col">
                    <h4>About</h4>
                    <p>App</p>
                    <p>Analytics</p>
                    <p>Token Lists</p>
                    <p>Defi</p>
                </div>
            </div>
        </div>
    )
}

export default Footer
